// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Assignment from "@material-ui/icons/Assignment";
import Kitchen from "@material-ui/icons/Kitchen";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import LocalShipping from "@material-ui/icons/LocalShipping";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import ReceiptIcon from '@material-ui/icons/Receipt';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SyncIcon from '@material-ui/icons/Sync';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import MapIcon from '@mui/icons-material/Map';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import React from "react";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import TableList from "views/TableList/TableList.js";
import Report from "views/Report/Report.js";
import Comission from "views/Comission/Comission.js";
import Sell from "views/Sell/Sell.js";
import Order from "views/Order/Order.js";
import Products from "views/Products/Products.js";
import Clients from "views/Clients/Clients.js";
import Sellsman from "views/Sellsman/Sellsman.js";
import Deliverymans from "views/Deliverymans/Deliverymans.js";
import Help from "views/Help/Help.js";
import Synthetics from "views/Synthetic/Synthetic";
import Analytical from "views/Analytical/Analytical";
import SubSynthetic from "views/SubSynthetic/SubSynthetic";
import Debit from "views/Debit/Debit";
import Cars from "views/Cars/Cars";
import BatchToCarAdmin from "views/BatchToCarAdmin/BatchToCarAdmin";
import Region from "views/Region/Region";
import SellNoFiscal from "views/SellNoFiscal/SellNoFiscal";
import Occurrence from "views/Occurrence/Ocurrence";

const dashboardRoutes = [
  {
    path: "/help",
    name: "AJUDA",
    icon: LocalShipping,
    component: Help,
    layout: "/admin"
  },
  {
    path: "/dashboard",
    name: "Início",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/table",
    name: "Entradas",
    icon: "content_paste",
    component: TableList,
    layout: "/admin"
  },
  {
    path: "/sell",
    name: "Vendas",
    icon: "payments",
    component: Sell,
    layout: "/admin"
  },
  {
    path: "/no-fiscal",
    name: "Vendas não fiscal",
    icon: "payments",
    component: SellNoFiscal,
    layout: "/admin"
  },
  {
    path: "/order",
    name: "Pedidos",
    icon: ReceiptIcon,
    component: Order,
    layout: "/admin"
  },
  {
    path: "/reports",
    name: "Relatórios",
    icon: Assignment,
    component: Report,
    layout: "/admin"
  },
  {
    path: "/comssion",
    name: "Comissão",
    icon: AccountBalanceIcon,
    component: Comission,
    layout: "/admin"
  },
  {
    path: "/products",
    name: "Produtos",
    icon: Kitchen,
    component: Products,
    layout: "/admin"
  },
  {
    path: "/clients",
    name: "Clientes",
    icon: AssignmentInd,
    component: Clients,
    layout: "/admin"
  },
  {
    path: "/selsman",
    name: "Vendedores",
    icon: MonetizationOnIcon,
    component: Sellsman,
    layout: "/admin"
  },
  {
    path: "/deliverymans",
    name: "Entregadores",
    icon: LocalShipping,
    component: Deliverymans,
    layout: "/admin"
  },
  {
    path: "/cars",
    name: "Carros",
    icon: DirectionsCar,
    component: Cars,
    layout: "/admin"
  },
  {
    path: "/road-map",
    name: "Roteiro",
    icon: MapIcon,
    component: BatchToCarAdmin,
    layout: "/admin",
  },
  {
    path: "/region",
    name: "Região",
    icon: LocationSearchingIcon,
    component: Region,
    layout: "/admin",
  },
  {
    path: "/occurrence",
    name: "Ocorrências",
    icon: AssignmentLateIcon,
    component: Occurrence,
    layout: "/admin",
  },
  {
    path: "/finance",
    name: "Finaceiro",
    icon: SyncIcon,
    component: Synthetics,
    layout: "/admin"
  },
  {
    path: "/synthetics",
    name: "Sintéticos",
    icon: SyncIcon,
    component: Synthetics,
    layout: "/admin"
  },
  {
    path: "/analytical",
    name: "Analítico",
    icon: SyncIcon,
    component: Analytical,
    layout: "/admin"
  },
  {
    path: "/subsynthetic",
    name: "SubSintetico",
    icon: SyncIcon,
    component: SubSynthetic,
    layout: "/admin"
  },
  {
    path: "/debit",
    name: "Lançamentos",
    icon: SyncIcon,
    component: Debit,
    layout: "/admin"
  }
];

export default dashboardRoutes;
